<nz-divider [nzText]="travelers" nzOrientation="center">
  <ng-template #travelers>
    <h5>{{ 'PERSONAL_DATA_FORM.RESIDENCE_CARD_OR_DOCUMENT_AUTHORIZING' | translate }}</h5>
  </ng-template>
</nz-divider>
<div class="row">
  @if (controls.stayEntitlingDocumentIssueDate; as stayEntitlingDocumentIssueDate) {
    <div class="standard-form-field stayEntitlingDocumentIssueDate-field required-field">
      <label
        for="stayEntitlingDocumentIssueDateInput"
        [class.invalid]="stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline" (click)="stayEntitlingDocumentIssueDatePicker.open()">
        <input
          matInput
          (focus)="stayEntitlingDocumentIssueDatePicker.open()"
          id="stayEntitlingDocumentIssueDateInput"
          #applicantStayEntitlingDocumentIssueDate
          [matDatepicker]="stayEntitlingDocumentIssueDatePicker"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.PLACEHOLDER' | translate }}"
          [min]="minValidDate"
          [max]="maxValidDate"
          [readonly]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="
            stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid ? 'true' : null
          "
          [attr.aria-describedby]="
            stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid
              ? 'stayEntitlingDocumentIssueDateError'
              : null
          "
          [formControl]="stayEntitlingDocumentIssueDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="stayEntitlingDocumentIssueDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #stayEntitlingDocumentIssueDatePicker
          [startView]="'month'"
          [startAt]="stayEntitlingDocumentIssueDate.value || documentIssuePickerStartDate"
          (closed)="applicantStayEntitlingDocumentIssueDate.blur()">
        </mat-datepicker>
        @if (stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid) {
          <mat-error id="stayEntitlingDocumentIssueDateError">
            {{ stayEntitlingDocumentIssueDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.stayEntitlingDocumentIssuedBy; as stayEntitlingDocumentIssuedBy) {
    <div class="standard-form-field widened-field stayEntitlingDocumentIssuedBy-field required-field">
      <label
        for="stayEntitlingDocumentIssuedByInput"
        [class.invalid]="stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid">
        {{ 'PERSONAL_DATA_FORM.STAY-ENTITLING-DOCUMENT-ISSUED-BY.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="stayEntitlingDocumentIssuedByInput"
          type="text"
          minLength="1"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.STAY-ENTITLING-DOCUMENT-ISSUED-BY.PLACEHOLDER' | translate }}"
          [formControl]="stayEntitlingDocumentIssuedBy"
          [attr.aria-required]="true"
          [attr.aria-invalid]="
            stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid ? 'true' : null
          "
          [attr.aria-describedby]="
            stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid
              ? 'stayEntitlingDocumentIssuedByError'
              : null
          " />
        @if (stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid) {
          <mat-error id="stayEntitlingDocumentIssuedByError">
            {{ stayEntitlingDocumentIssuedBy.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
